/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".error[_ngcontent-%COMP%]::after, .pending[_ngcontent-%COMP%]::after, .success[_ngcontent-%COMP%]::after{margin-left:20px}.success[_ngcontent-%COMP%]::after{content:'success \u2705'}.error[_ngcontent-%COMP%]::after{content:'error \u274C'}.pending[_ngcontent-%COMP%]::after{content:'...pending \u23F3'}\n/*# sourceMappingURL=transactions-window.component.css.map*/"];
export { styles as styles };
